var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg15(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.539 12.706l-.728-.728a.228.228 0 00-.123-.064l-4.333-.722-4.337-2.168a.227.227 0 10-.203.407l3.505 1.753h-4.718l-.665-1.33a.227.227 0 00-.431.101v1.229h-3.27l-.666-1.33a.227.227 0 00-.43.101v1.229H2.727a.227.227 0 00-.228.227v2.911c0 .109.076.202.183.223l2.13.426a1.68 1.68 0 002.937.305h9.605a1.682 1.682 0 002.768 0h.799c.035 0 .07-.007.102-.023l1.455-.728a.228.228 0 00.126-.204v-1.455a.224.224 0 00-.066-.16zM6.367 15.55a1.23 1.23 0 01-1.229-1.228 1.23 1.23 0 111.228 1.228zm12.372 0a1.23 1.23 0 111.228-1.228 1.23 1.23 0 01-1.228 1.228z",
    fill: "#0B0B0B",
    fillRule: "evenodd"
  })));
}

export default Svg15;